<app-navbar
  (signOutEmitter)="signOut()"
  (loadedEmitter)="onLoaded()"
  [email]="email"
  [user]="user"
  [isAuthenticated]="isAuthenticated"
>
</app-navbar>

<!-- <app-dc-loading *ngIf="loading && isAuthenticated"> Initializing... </app-dc-loading> -->
<router-outlet></router-outlet>
<div class="app-version">
  Build Number: {{ appBuildNumber }}<br />
  Build Date: {{ appBuildDateString }}<br />
  Version: {{ appVersion.substring(0, 10) }}<br />
</div>
